import { SOCIAL_BASE_URLS } from '@/config/socials'

export default {
  methods: {
    formatSocialURL(social, input) {
      // Crear cache si no existe
      this._socialURLCache = this._socialURLCache || {};
      const cacheKey = `${social}_${input}`;
      
      if (this._socialURLCache[cacheKey]) return this._socialURLCache[cacheKey];

      if (!input) {
        this._socialURLCache[cacheKey] = '';
        return '';
      }

      let result;
      
      // Si ya es una URL completa
      if (input.includes('.') && (input.startsWith('http') || input.startsWith('www'))) {
        result = this.ensureHttps(input);
      }
      // Casos especiales
      else if (social === 'paypal' && (input.includes('paypal.me') || input.includes('paypalme'))) {
        result = 'https://www.paypal.me/' + input.split(/[/]/).pop().replace('@', '');
      }
      else if (social === 'web') {
        result = this.ensureHttps(input);
      }
      else {
        const baseUrl = SOCIAL_BASE_URLS[social] || '';
        let formattedInput = social === 'email' ? input : input.replace('@', '');
        
        const domainPattern = new RegExp(`^(?:https?://)?(?:www\\.)?${social}\\.com/?`, 'i');
        formattedInput = formattedInput.replace(domainPattern, '');
        
        result = baseUrl + formattedInput.split(/[/]/).pop();
      }

      this._socialURLCache[cacheKey] = result;
      return result;
    },

    ensureHttps(url) {
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      return 'https://' + url;
    }
  }
}